import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Contracts from "@/pages/Contracts";
import ContractDetail from "@/pages/ContractDetail";
import Municipalities from "@/pages/Municipalities";
import Import from "@/pages/Import";
import Reports from "@/pages/Reports";
import AdminUsers from "@/pages/AdminUsers";
import Aditivos from "@/pages/Aditivos";
import Notificacoes from "@/pages/Notificacoes";
import Saldos from "@/pages/Saldos";
import Pesquisas from "@/pages/Pesquisas";
import PesquisaDetail from "@/pages/PesquisaDetail";
import Signatarios from "@/pages/Signatarios";
import Despachos from "@/pages/Despachos";
import DespachoEditor from "@/pages/DespachoEditor";
import DocumentEditor from "@/pages/DocumentEditor";
import PAC from "@/pages/PAC";
import Demandas from "@/pages/Demandas";
import RenovacoesSaldo from "@/pages/RenovacoesSaldo";
import Planejamento from "@/pages/Planejamento";
import ETP from "@/pages/ETP";
import TR from "@/pages/TR";
import MatrizRiscos from "@/pages/MatrizRiscos";
import FornecedorPainel from "@/pages/FornecedorPainel";
import FornecedorContratos from "@/pages/FornecedorContratos";
import FornecedorContratoDetalhe from "@/pages/FornecedorContratoDetalhe";
import FornecedorMedicoes from "@/pages/FornecedorMedicoes";
import MedicaoEditor from "@/pages/MedicaoEditor";
import MedicoesFiscalizacao from "@/pages/MedicoesFiscalizacao";
import MedicaoAnalise from "@/pages/MedicaoAnalise";
import AdminFornecedores from "@/pages/AdminFornecedores";
import FornecedorLogin from "@/pages/FornecedorLogin";
import RedefinirSenha from "@/pages/RedefinirSenha";
import Engenharia from "@/pages/Engenharia";
import OrcamentoEditor from "@/pages/OrcamentoEditor";

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
        <div translate="no"><Toaster theme="dark" position="top-right" richColors /></div>
        <ErrorBoundary>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/fornecedor/login" element={<FornecedorLogin />} />
            <Route path="/fornecedor/redefinir-senha" element={<RedefinirSenha />} />
            <Route element={<Layout />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/contratos" element={<Contracts />} />
              <Route path="/contratos/:id" element={<ContractDetail />} />
              <Route path="/municipios" element={<Municipalities />} />
              <Route path="/relatorios" element={<Reports />} />
              <Route path="/importar" element={<Import />} />
              <Route path="/aditivos" element={<Aditivos />} />
              <Route path="/notificacoes" element={<Notificacoes />} />
              <Route path="/saldos" element={<Saldos />} />
              <Route path="/pesquisas" element={<Pesquisas />} />
              <Route path="/pesquisas/:id" element={<PesquisaDetail />} />
              <Route path="/signatarios" element={<Signatarios />} />
              <Route path="/despachos" element={<Despachos />} />
              <Route path="/despachos/:id/editor" element={<DespachoEditor />} />
              <Route path="/editor/aditivo/:id" element={<DocumentEditor docType="aditivo" />} />
              <Route path="/editor/renovacao/:id" element={<DocumentEditor docType="renovacao" />} />
              <Route path="/editor/execucao/:id" element={<DocumentEditor docType="execucao" />} />
              <Route path="/editor/pesquisa/:id" element={<DocumentEditor docType="pesquisa" />} />
              <Route path="/editor/pac/:id" element={<DocumentEditor docType="pac" />} />
              <Route path="/pac" element={<PAC />} />
              <Route path="/demandas" element={<Demandas />} />
              <Route path="/renovacoes-saldo" element={<RenovacoesSaldo />} />
              <Route path="/planejamento" element={<Planejamento />} />
              <Route path="/etps" element={<ETP />} />
              <Route path="/trs" element={<TR />} />
              <Route path="/matrizes-riscos" element={<MatrizRiscos />} />
              <Route path="/admin/usuarios" element={<AdminUsers />} />
              <Route path="/admin/fornecedores" element={<AdminFornecedores />} />
              <Route path="/medicoes" element={<MedicoesFiscalizacao />} />
              <Route path="/medicoes/:id" element={<MedicaoAnalise />} />
              <Route path="/engenharia" element={<Engenharia />} />
              <Route path="/engenharia/orcamentos/:id" element={<OrcamentoEditor />} />
              <Route path="/fornecedor/engenharia" element={<Engenharia />} />
              <Route path="/fornecedor/engenharia/orcamentos/:id" element={<OrcamentoEditor />} />
              <Route path="/fornecedor" element={<FornecedorPainel />} />
              <Route path="/fornecedor/contratos" element={<FornecedorContratos />} />
              <Route path="/fornecedor/contratos/:id" element={<FornecedorContratoDetalhe />} />
              <Route path="/fornecedor/medicoes" element={<FornecedorMedicoes />} />
              <Route path="/fornecedor/medicoes/:id" element={<MedicaoEditor />} />
            </Route>
          </Routes>
        </ErrorBoundary>
      </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
